import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.css']
})
export class ProgressComponent implements OnChanges {
  @Input() progress = 0;
  constructor() { }

  ngOnChanges(): void {
    
  }

}
